/* eslint-disable max-params */
import { API, Auth, Storage } from "aws-amplify";
import { TypeCommon } from "models/common";
import { addSuffixtoString } from "utils/common.util";

export const getAccessJwtToken = async (): Promise<TypeCommon> => {
  try {
    const session: TypeCommon = await Auth.currentSession();
    const newtoken = session?.getIdToken().getJwtToken();
    return newtoken;
  } catch (err) {
    return "";
  }
};

export const get = async (
  apiName: string,
  url: string,
  params?: TypeCommon,
  headers?: TypeCommon,
  accessToken?: string,
): Promise<TypeCommon> => {
  const token = accessToken ?? (await getAccessJwtToken());
  return API.get(apiName, url, {
    headers: {
      Authorization: token,
      ...headers,
    },
    queryStringParameters: params,
  });
};

export const post = async (
  apiName: string,
  url: string,
  body: TypeCommon,
  params?: TypeCommon,
  headers?: TypeCommon,
  accessToken?: string,
): Promise<TypeCommon> => {
  const token = accessToken ?? (await getAccessJwtToken());
  return API.post(apiName, url, {
    body,
    headers: {
      Authorization: token,
      ...headers,
    },
    queryStringParameters: params,
  });
};

export const put = async (
  apiName: string,
  url: string,
  body: TypeCommon,
  params?: TypeCommon,
  headers?: TypeCommon,
): Promise<TypeCommon> => {
  const token = await getAccessJwtToken();
  return API.put(apiName, url, {
    body,
    headers: {
      Authorization: token,
      ...headers,
    },
    queryStringParameters: params,
  });
};

export const del = async (
  apiName: string,
  url: string,
  body: TypeCommon,
  params?: TypeCommon,
  headers?: TypeCommon,
): Promise<TypeCommon> => {
  const token = await getAccessJwtToken();
  return API.del(apiName, url, {
    body,
    headers: {
      Authorization: token,
      ...headers,
    },
    queryStringParameters: params,
  });
};
export const uploadImage = async (
  imageName: string,
  file: TypeCommon,
): Promise<void> => {
  const data = await post("form", "/presigned-url", {
    key: imageName,
  });
  const formData = new FormData();
  Object.entries(data?.data.fields).forEach(([key, value]) => {
    formData.append(key, value as TypeCommon);
  });
  formData.append("file", file);
  if (data?.data) {
    await fetch(data?.data?.url, {
      method: "POST",
      body: formData,
    });
  }
};

// Generic file upload function
export const uploadFile = async (file: File, index?: number): Promise<string> => {
  const user = await Auth.currentCredentials();
  const userId = user?.identityId;

  if (!userId) {
    throw new Error("User not authenticated");
  }

  // // Check file type if allowedTypes is specified
  // if (options?.allowedTypes && !options.allowedTypes.includes(file.type)) {
  //     throw new Error(`File type ${file.type} not allowed`);
  // }

  // // Check file size if maxSizeMB is specified
  // if (options?.maxSizeMB && file.size > options.maxSizeMB * 1024 * 1024) {
  //     throw new Error(`File size exceeds ${options.maxSizeMB}MB limit`);
  // }

  const extension = file.name.split(".").pop();

  const fileToUpload = file;

  // // Resize image if needed
  // if (options?.resizeIfImage && file.type.includes('image')) {
  //     fileToUpload = await resizeFile(file);
  // }

  // Upload to S3
  const data = await Storage.put(
    `${addSuffixtoString()}${index ?? ""}.${extension}`,
    fileToUpload,
    {
      level: "protected",
      contentType: fileToUpload.type,
    },
  );

  return `protected/${userId}/${data?.key}`;
};

// Specific upload functions that use the generic uploadFile
export const uploadImages = async (
  fileName: string,
  file: File,
): Promise<string> => {
  return uploadFile(file);
};

export const uploadEstimateFile = async (
  fileName: string,
  file: File,
): Promise<{ url: string }> => {
  const url = await uploadFile(file);
  return { url };
};
